export default Object.freeze({
  Offline: "Offline",
  Faulted: "Faulted",
  Available: "Available",
  Preparing: "Preparing",
  Finishing: "Finishing",
  Charging: "Charging",
  Unavailable: "Unavailable",
});
